<h2 mat-dialog-title>Add Database User</h2>

<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      label="Server"
      placeholder="Select Server"
      type="select"
      formControlName="server"
      [options]="(servers$ | async) ?? []"
      [(searchText)]="serverSearchText"
      [errorMessages]="{
        required: 'Server is required',
      }"
    ></app-input-field>

    <app-input-field
      label="Website"
      placeholder="Select Website"
      type="autocomplete"
      formControlName="websiteId"
      [options]="websiteOptions()"
      [(searchText)]="websiteSearchText"
      [errorMessages]="{
        required: 'Website is required',
      }"
    ></app-input-field>

    <app-input-field
      label="Database Name"
      placeholder="Select Database"
      type="select"
      formControlName="databaseId"
      [options]="databaseOptions()"
      [errorMessages]="{
        required: 'Database is required',
      }"
    ></app-input-field>

    <app-input-field
      label="Database User"
      placeholder="Type Database User"
      type="text"
      formControlName="username"
    ></app-input-field>

    <app-input-field
      label="Password"
      placeholder="Type Password"
      type="password"
      formControlName="password"
      autocomplete="new-password"
    ></app-input-field>

    <app-input-field
      label="Confirm Password"
      placeholder="Confirm Password"
      type="password"
      formControlName="passwordConf"
      [errorMessages]="{
        required: 'Confirm password is required',
        passwordMismatch: 'Passwords do not match',
      }"
    ></app-input-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">Add Database User</button>

  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
